module.exports = __webpack_public_path__ + "static/media/txt.28cbce52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/txt.svg
// module id = 606
// module chunks = 0